import { render, staticRenderFns } from "./detecation-items.vue?vue&type=template&id=38e188f1&scoped=true"
import script from "./detecation-items.vue?vue&type=script&lang=ts"
export * from "./detecation-items.vue?vue&type=script&lang=ts"
import style0 from "./detecation-items.vue?vue&type=style&index=0&id=38e188f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e188f1",
  null
  
)

export default component.exports